import { isGDPRCountry } from '@wework/www-form-utils';
import { debounce } from 'client/javascript/util/utils';
import { DEFAULT_TABS_CLASSES, TabsNavigation } from 'client/javascript/tabs_navigation';
import { updatePhoneNumbersWithGeoData, geoData } from './geo';
import { trackInteraction } from './analytics';
import { addTrackPhoneNumberClickEvents } from './phone_analytics';

export async function setupPhoneNumbersOnPage() {
  const { countryCode } = await geoData;
  updatePhoneNumbersWithGeoData(countryCode);
  addTrackPhoneNumberClickEvents();
}

export function setUpMobileMenuListeners() {
  const mobileMenuOpenBtn = document.getElementById('mobile-menu-open');
  mobileMenuOpenBtn.addEventListener('click', () => {
    document.body.classList.add('mobile-menu-open');
    document.body.classList.add('js-lock-scroll');
    trackInteraction({
      label: 'Mobile Menu',
      is_open: true
    });
  });

  window.addEventListener('resize', debounce(closeMobileMenu, 200));

  const mobileMenuCloseBtn = document.getElementById('mobile-menu-close');
  mobileMenuCloseBtn.addEventListener('click', () => {
    document.body.classList.remove('mobile-menu-open');
    document.body.classList.remove('js-lock-scroll');
  });
}

export async function setupConsentForGDPR() {
  const { countryCode } = await geoData;
  const isCountryRegulatedByGDPR = isGDPRCountry(countryCode);

  if (isCountryRegulatedByGDPR) {
    Array.from(document.querySelectorAll('.gdpr, .gdpr-wrapper')).forEach((el) => {
      el.style.display = 'block'; // eslint-disable-line no-param-reassign
    });
  } else {
    Array.from(document.querySelectorAll('.gdpr-checkbox')).forEach((el) => {
      el.checked = true; // eslint-disable-line no-param-reassign
    });
  }
}

function closeMobileMenu() {
  const windowIsLargerThanTablet = window.innerWidth >= 1195;
  if (windowIsLargerThanTablet) {
    document.body.classList.remove('mobile-menu-open');
    document.body.classList.remove('js-lock-scroll');
  }
}

export function setupFooterTabs() {
  const footerNode = document.querySelector('footer.page-footer');
  if (footerNode) {
    TabsNavigation.init({
      contents: {
        elements: footerNode.querySelectorAll(`.${DEFAULT_TABS_CLASSES.CARD_ITEM}`),
        activeClass: DEFAULT_TABS_CLASSES.CARD_ITEM_ACTIVE
      },
      tabs: {
        elements: footerNode.querySelectorAll(`.${DEFAULT_TABS_CLASSES.TAB_ITEM}`),
        activeClass: DEFAULT_TABS_CLASSES.TAB_ITEM_ACTIVE
      }
    });
  }
}
